export default "__VITE_ASSET__BIS7Tjq$__"